import { type JSX } from 'react';

import { Text } from 'Components/Text/Text';

/** A SummIT Guide™ recommendation and the corresponding value that the user last saved. */
export interface SummitGuideRecommendationComparison {
    recommended?: number;
    saved?: number;
}

export interface SummitGuideOverwriteNoticeProps {
    comparisons: SummitGuideRecommendationComparison[];
}

const isSet = (value?: number): boolean => value !== undefined && value !== 0;

/**
 * Explains to the user why a difference between a SummIT Guide™ recommendation might differ from their own selection.
 * Comparisons are made against the user's last saved values rather than the in-memory form state, so the notice doesn't show/hide while the user is mid-edit.
 */
export const SummitGuideOverwriteNotice = (props: SummitGuideOverwriteNoticeProps): JSX.Element => {
    const anyRecommendationDiffers = props.comparisons.some((comparison) => isSet(comparison.recommended) && isSet(comparison.saved) && comparison.recommended !== comparison.saved);

    if (!anyRecommendationDiffers) {
        return <></>;
    }

    return (
        <Text variant="Text3" color="darkGray" noStyles>
            {props.comparisons.length > 1 ? 'SummIT Guide™ recommends different values, but it will never overwrite values selected by a user.' : 'SummIT Guide™ recommends a different value, but it will never overwrite a value selected by a user.'}
        </Text>
    );
};
